
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface ItemsHeaderProps {
  onAddItem: () => void;
}

export const ItemsHeader = ({ onAddItem }: ItemsHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h3 className="text-lg font-medium">Products</h3>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onAddItem}
        className="flex items-center gap-2"
      >
        <Plus className="h-4 w-4" />
        Add Product
      </Button>
    </div>
  );
};
